/* HeyBear x 7-Eleven · Scan To Japan */
HB.section('scanwin', function (root) {
  'use strict';

  HB.reveal(root);

  var journey = root.querySelector('[data-sw-journey]');
  var svg = root.querySelector('[data-sw-run-svg]');
  var car = root.querySelector('[data-sw-run-car]');
  var carImage = car ? car.querySelector('img') : null;
  var path = null;
  var pathLength = 0;
  var facing = 'R';
  var lastProgress = 0;
  var scrollingBack = false;
  var raf = 0;
  var resizeTimer = 0;

  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }

  function routePath(points) {
    var d = 'M' + points[0][0] + ',' + points[0][1];
    for (var i = 0; i < points.length - 1; i += 1) {
      var p0 = points[i - 1] || points[i];
      var p1 = points[i];
      var p2 = points[i + 1];
      var p3 = points[i + 2] || p2;
      var tension = 0.5;
      d += ' C' + (p1[0] + (p2[0] - p0[0]) * tension / 2) + ',' + (p1[1] + (p2[1] - p0[1]) * tension / 2)
        + ' ' + (p2[0] - (p3[0] - p1[0]) * tension / 2) + ',' + (p2[1] - (p3[1] - p1[1]) * tension / 2)
        + ' ' + p2[0] + ',' + p2[1];
    }
    return d;
  }

  function buildRoute() {
    if (!journey || !svg || !car || !carImage) return;
    var width = journey.clientWidth;
    var height = journey.offsetHeight;
    var journeyBox = journey.getBoundingClientRect();
    var mobile = width < 900;
    var cards = Array.prototype.slice.call(journey.querySelectorAll('.sw-step'));
    var points = [[mobile ? width * 0.82 : width * 0.5, mobile ? 36 : 18]];

    cards.forEach(function (card, index) {
      var box = card.getBoundingClientRect();
      var localLeft = box.left - journeyBox.left;
      var localRight = box.right - journeyBox.left;
      var x;
      if (mobile) x = index % 2 ? width * 0.82 : width * 0.18;
      else if (card.closest('.sw-step-row--right')) x = localLeft / 2;
      else x = localRight + (width - localRight) / 2;
      points.push([x, box.top - journeyBox.top + box.height / 2]);
    });

    var destination = journey.querySelector('[data-sw-destination]');
    var store = destination ? destination.querySelector('.sw-store') : null;
    var destinationBox = (store || destination).getBoundingClientRect();
    points.push([width * 0.5, destinationBox.top - journeyBox.top + destinationBox.height * 0.62]);

    var d = routePath(points);
    var roadWidth = mobile ? 54 : 72;
    svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    svg.innerHTML = '<path class="sw-run-edge" d="' + d + '" stroke-width="' + (roadWidth + 8) + '"/>'
      + '<path class="sw-run-tar" d="' + d + '" stroke-width="' + roadWidth + '"/>'
      + '<path class="sw-run-dash" data-sw-run-path d="' + d + '"/>'
      + points.slice(1, -1).map(function (point, index) {
        return '<g class="sw-run-pin" transform="translate(' + point[0] + ',' + point[1] + ')"><circle r="' + (mobile ? 16 : 20) + '"/><text>' + (index + 1) + '</text></g>';
      }).join('');
    path = svg.querySelector('[data-sw-run-path]');
    pathLength = path ? path.getTotalLength() : 0;
    placeCar();
  }

  function placeCar() {
    raf = 0;
    if (!journey || !path || !pathLength || !car || !carImage) return;
    var box = journey.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    var progress = HB.reduce ? 1 : clamp((viewportHeight * 0.55 - box.top - 160) / Math.max(1, box.height - 160 - viewportHeight * 0.25));
    var distance = progress * pathLength;
    var point = path.getPointAtLength(distance);
    var nextPoint = path.getPointAtLength(Math.min(pathLength, distance + 2));
    var previousPoint = path.getPointAtLength(Math.max(0, distance - 2));
    var dx = nextPoint.x - previousPoint.x;
    var dy = nextPoint.y - previousPoint.y;

    if (Math.abs(progress - lastProgress) > 0.0005) {
      scrollingBack = progress < lastProgress;
      lastProgress = progress;
    }
    if (scrollingBack) { dx = -dx; dy = -dy; }

    var nextFacing = dx < -0.2 ? 'L' : dx > 0.2 ? 'R' : facing;
    if (nextFacing !== facing) {
      facing = nextFacing;
      carImage.src = journey.getAttribute(facing === 'L' ? 'data-car-l' : 'data-car-r');
    }
    var angle = Math.atan2(dy, Math.abs(dx)) * 180 / Math.PI;
    angle = Math.max(-28, Math.min(28, angle));
    if (facing === 'L') angle = -angle;
    car.style.transform = 'translate3d(' + (point.x - car.offsetWidth / 2) + 'px,' + (point.y - car.offsetHeight * 0.82) + 'px,0) rotate(' + angle + 'deg)';
  }

  function requestPlace() {
    if (!raf) raf = requestAnimationFrame(placeCar);
  }

  function requestBuild() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(buildRoute, 120);
  }

  if (journey && svg && car && carImage) {
    buildRoute();
    if (!HB.reduce) {
      window.addEventListener('scroll', requestPlace, { passive: true });
      window.addEventListener('resize', requestBuild, { passive: true });
    }
    if (document.fonts) document.fonts.ready.then(buildRoute);
    Array.prototype.slice.call(journey.querySelectorAll('img')).forEach(function (image) {
      if (!image.complete) image.addEventListener('load', buildRoute, { once: true });
    });
    setTimeout(buildRoute, 800);
  }

  var dialog = root.querySelector('[data-sw-terms]');
  var openers = Array.prototype.slice.call(root.querySelectorAll('[data-sw-open-terms]'));
  var closer = root.querySelector('[data-sw-close-terms]');
  var lastTrigger = null;

  function openTerms(event) {
    if (!dialog) return;
    lastTrigger = event.currentTarget;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    HB.lock(true);
  }

  function closeTerms() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function afterClose() {
    HB.lock(false);
    if (lastTrigger) lastTrigger.focus();
  }

  function onBackdrop(event) {
    if (event.target === dialog) closeTerms();
  }

  openers.forEach(function (opener) { opener.addEventListener('click', openTerms); });
  if (closer) closer.addEventListener('click', closeTerms);
  if (dialog) {
    dialog.addEventListener('close', afterClose);
    dialog.addEventListener('cancel', afterClose);
    dialog.addEventListener('click', onBackdrop);
  }

  return function () {
    cancelAnimationFrame(raf);
    clearTimeout(resizeTimer);
    window.removeEventListener('scroll', requestPlace);
    window.removeEventListener('resize', requestBuild);
    openers.forEach(function (opener) { opener.removeEventListener('click', openTerms); });
    if (closer) closer.removeEventListener('click', closeTerms);
    if (dialog) {
      dialog.removeEventListener('close', afterClose);
      dialog.removeEventListener('cancel', afterClose);
      dialog.removeEventListener('click', onBackdrop);
    }
    HB.lock(false);
  };
});
